
export default function Logo({...props}) {
    return (<>
        <img
            {...props}
            src="/logo.svg"
            alt="Punto Pagos"
        />
    </>);
}